//@@@ https://mui.com/material-ui/react-stepper/#text-with-carousel-effect @@@@
import {imgHttpFolder} from '../../redux/globalVariable'
import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MobileStepper from '@mui/material/MobileStepper';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);
console.log(`${imgHttpFolder}/about/01.jpeg`)
// const images = [
//   {
//     label: 'San Francisco – Oakland Bay Bridge, United States',
//     imgPath:
//       `${imgHttpFolder}/about/01.jpeg`,
//   },
//   {
//     label: 'Bird',
//     imgPath:
//       'https://images.unsplash.com/photo-1538032746644-0212e812a9e7?auto=format&fit=crop&w=400&h=250&q=60',
//   },
//   {
//     label: 'Bali, Indonesia',
//     imgPath:
//       'https://images.unsplash.com/photo-1537996194471-e657df975ab4?auto=format&fit=crop&w=400&h=250',
//   },
//   {
//     label: 'Goč, Serbia',
//     imgPath:
//       'https://images.unsplash.com/photo-1512341689857-198e7e2f3ca8?auto=format&fit=crop&w=400&h=250&q=60',
//   },
// ];
const images = [
  {
    label: '',
    imgPath:
    './pimages/about/b1.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b2.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b3.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b4.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b5.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b6.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b7.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b8.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b9.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b10.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b11.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b12.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b13.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b14.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b15.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b16.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b17.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b18.jpg',
  },
  {
    label: '',
    imgPath:
    './pimages/about/b19.jpg',
  },
];

function SwipeableTextMobileStepper() {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step: number) => {
    setActiveStep(step);
  };

  return (
    <Box sx={{ maxWidth: 600, flexGrow: 1 }}>
      <Paper
        square
        elevation={0}
        sx={{
          display: 'flex',
          alignItems: 'center',
          height: 50,
          pl: 2,
          bgcolor: 'background.default',
        }}
      >
        <Typography>{images[activeStep].label}</Typography>
      </Paper>
      <AutoPlaySwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      >
        {images.map((step, index) => (
          <div key={step.label}>
            {Math.abs(activeStep - index) <= 2 ? (
              <Box
                component="img"
                sx={{
                 //height: 390,
                  maxheight: 338,
                  display: 'block',
                  //maxWidth: 400,
                  maxWidth: 600,
                  overflow: 'hidden',
                  width: '100%',
                }}
                src={step.imgPath}
                alt={step.label}
              />
            ) : null}
          </div>
        ))}
      </AutoPlaySwipeableViews>
      <MobileStepper
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            Next
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      />
    </Box>

  );
}

export default SwipeableTextMobileStepper;
